import api from './axiosClient'
import { UserDashboardProto, UserDashboardsProto } from '../../proto/generated/user-preference'
import store from '../../store'
import { updateLayout } from '../../reducer/widgetDashboard.reducer'

export const getUserDashboards = async (): Promise<UserDashboardProto[]> => {
    return new Promise((resolve, reject) => {
        const url = `/user-dashboards-layouts`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            if (!response || !response.data) {
                resolve([]);
                return;
            }
            const decodedData = UserDashboardsProto.decode(new Uint8Array(response.data))
            resolve(decodedData.userDashboards)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const saveUserDashboard = async (args: { dashboard: UserDashboardProto }): Promise<UserDashboardProto> => {
    return new Promise((resolve, reject) => {
        const url = `/user-dashboards-layouts`
        api.post(url, JSON.stringify(args.dashboard), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            if (response.status !== 200) reject('not saved')
            else {
                const decodedData = UserDashboardProto.decode(new Uint8Array(response.data))
                resolve(decodedData)
            }
        }).catch((error) => {
            reject(error)
        })
    })
}

export const deleteUserDashboard = async (args: { dashboard: Partial<UserDashboardProto> }): Promise<String> => {
    return new Promise((resolve, reject) => {
        const url = `/user-dashboards-layouts`
        api.delete(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            data: JSON.stringify(args.dashboard),
            responseType: 'arraybuffer'
        }).then(async (response) => {
            if (response.status !== 200) reject('not deleted')
            else {
                const decodedData = UserDashboardProto.decode(new Uint8Array(response.data))
                resolve(decodedData.id)
            }
        }).catch((error) => {
            reject(error)
        })
    })
}

export const updateUserDashboard = async (args: { dashboard: UserDashboardProto }): Promise<UserDashboardProto> => {
    return new Promise((resolve, reject) => {
        const url = `/user-dashboards-layouts/update`
        api.post(url, JSON.stringify(args.dashboard), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            if (response.status !== 200) reject('not updated')
            else {
                const decodedData = UserDashboardProto.decode(new Uint8Array(response.data))
                store.dispatch(updateLayout({ id: decodedData.id, layout: JSON.parse(decodedData.layout) }))
                resolve(decodedData);
            }
        }).catch((error) => {
            reject(error)
        })
    })
}

export const updateUserDashboardDefault = async (args: { dashboard: UserDashboardProto }): Promise<UserDashboardProto> => {
    return new Promise((resolve, reject) => {
        const url = `/user-dashboards-layouts/update-default`
        api.post(url, JSON.stringify(args.dashboard), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            if (response.status !== 200) reject('not updated')
            else {
                const decodedData = UserDashboardProto.decode(new Uint8Array(response.data))
                resolve(decodedData)
            }
        }).catch((error) => {
            reject(error)
        })
    })
}

export const toggleSharing = async (args: { dashboard: UserDashboardProto }): Promise<UserDashboardProto> => {
    const url = `/user-dashboards-layouts/update-sharing`;
    const response = await api.post(url, JSON.stringify(args.dashboard), {
        headers: {
            'Accept': 'application/x-protobuf'
        },
        responseType: 'arraybuffer'
    });
    if (response.status !== 200) {
        throw new Error('Failed to update sharing state');
    }
    return UserDashboardProto.decode(new Uint8Array(response.data));
};

export const fetchUserDashboardById = async (args: { LayoutId: string }): Promise<UserDashboardProto> => {
    return new Promise((resolve, reject) => {
        const url = `/user-dashboards-layouts/fetch?layoutId=${encodeURIComponent(args.LayoutId)}`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf',
                'X-Suppress-Error': 'true'
            },
            responseType: 'arraybuffer'
        }).then((response) => {
            if (response.status !== 200) {
                reject('Dashboard not found or access denied')
            } else {
                const decodedData = UserDashboardProto.decode(new Uint8Array(response.data))
                resolve(decodedData)
            }
        }).catch((error) => {
            reject(error)
        })
    })
}